import { mapCollection } from '../../utils/collection.utils';
import { SchedulerTaskStatus } from '../scheduler-task-status';

export class SchedulerTaskStatusBuilder {
  static fromJson(json) {
    return (json)
      ? new SchedulerTaskStatus(
        json.hash,
        json.schedulerTaskHash,
        json.status,
        json.duration,
        json.creationDate
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(SchedulerTaskStatusBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-status.builder.ts